import React from 'react'
import {Dropdown} from 'react-bootstrap'

interface ReportExportProps {
  onExportCsv: () => void
  onPrint: () => void
  onRefresh?: () => void
  showChart: boolean
  onToggleChart: () => void
  chartEnabled: boolean
  isExporting?: boolean
  isPrintLoading?: boolean
}

const ReportExport: React.FC<ReportExportProps> = ({
  onExportCsv,
  onPrint,
  onRefresh,
  showChart,
  onToggleChart,
  chartEnabled,
  isExporting = false,
  isPrintLoading = false,
}) => {
  return (
    <div className='d-flex gap-2 d-print-none'>
      {chartEnabled && (
        <button
          className={`btn btn-sm ${showChart ? 'btn-primary' : 'btn-light'}`}
          onClick={onToggleChart}
          title={showChart ? 'Hide Chart' : 'Show Chart'}
        >
          <i className='bi bi-bar-chart-fill'></i>
        </button>
      )}

      <button
        className='btn btn-light btn-sm'
        onClick={() => onRefresh ? onRefresh() : window.location.reload()}
        title='Refresh'
      >
        <i className='bi bi-arrow-clockwise'></i>
      </button>

      <Dropdown>
        <Dropdown.Toggle variant='light' size='sm' id='export-dropdown' disabled={isExporting}>
          {isExporting ? (
            <>
              <span
                className='spinner-border spinner-border-sm me-1'
                role='status'
                aria-hidden='true'
              ></span>
              Exporting...
            </>
          ) : (
            <>
              <i className='bi bi-download me-1'></i>
              Export
            </>
          )}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item onClick={onExportCsv}>
            <i className='bi bi-filetype-csv me-2 text-success'></i>
            Export as CSV
          </Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item onClick={onPrint} disabled={isPrintLoading}>
            {isPrintLoading ? (
              <>
                <span
                  className='spinner-border spinner-border-sm me-2 text-primary'
                  role='status'
                  aria-hidden='true'
                ></span>
                Loading all records...
              </>
            ) : (
              <>
                <i className='bi bi-printer me-2 text-primary'></i>
                Print Report
              </>
            )}
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  )
}

export default ReportExport
